





















































import { Vue, Component, Prop, Watch, Model } from "vue-property-decorator";
import debounce from "lodash/debounce";
import { stringIsNullOrEmpty } from "_P/strings";
import { Address } from "@/models/Address";
import GeoService, { GeoResp } from "../../services/Geo";

@Component({ inheritAttrs: false })
export default class ppdwAddress extends Vue {
    @Prop({ default: () => [] }) rules: Function[];
    @Prop() value: Address;
    @Prop({ default: "Адрес" }) label: string;
    @Prop({ default: "" }) placeholder: string;
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: false }) hideDetails: boolean;
    @Prop({ default: false }) showCheckbox: boolean;
    @Prop({ default: false }) dark: boolean;
    @Prop({ default: null }) from_bound: { value: string };
    @Prop({ default: null }) to_bound: { value: string };
    @Prop({ default: true }) top: boolean;

    isLoading: boolean = false;
    entries: GeoResp[] = [];
    search: string = "";
    isNeedSearch: boolean = true;

    created() {
        this.updateVisibleValue(true);
    }
    mounted() {
        this.checkSuccess(this.value, this.rules);
    }

    @Watch("value.value")
    updateVisibleValue(isInitial = false) {
        if (!!this.value) {
            this.entries.push(GeoResp.Create(this.value.value, this.value));
            this.isNeedSearch = false;
            if (!!this.value.value) this.search = this.value.value;
            if (!isInitial) this.checkSuccess(this.value, this.rules);
        }
    }

    get model(): GeoResp {
        if (!!this.value && !!this.value.value)
            return GeoResp.Create(
                !!this.value ? this.value.value : "",
                this.value
            );
        else return null;
    }
    set model(v: GeoResp) {
        if (stringIsNullOrEmpty(v.data?.zip)) {
            if (
                stringIsNullOrEmpty(v.data?.house) &&
                stringIsNullOrEmpty(v.data?.building) &&
                stringIsNullOrEmpty(v.data?.apartment)
            ) {
                this.$emit("input", v.data);
            } else {
                this.getData(v);
            }
        } else {
            this.$emit("input", v.data);
        }
    }

    private async getData(v: GeoResp) {
        try {
            let requestModel = {
                query: v.value,
                count: 1
            };
            this.entries = await GeoService.makeAdvancedQuery(requestModel);

            if (stringIsNullOrEmpty(this.entries[0].data.zip)) {
                let address = this.entries[0].data;
                let queryZip = "";
                queryZip += !!address.state ? address.state + "," : "";
                queryZip += !!address.region ? address.region + "," : "";
                queryZip += !!address.city ? address.city + "," : "";

                let requestZip = {
                    query: queryZip,
                    count: 1
                };

                let addressData = await GeoService.makeAdvancedQuery(
                    requestZip
                );

                if (!stringIsNullOrEmpty(addressData[0].data.zip)) {
                    this.entries[0].data.zip = addressData[0].data.zip;
                } else {
                    console.log(
                        "Почтовый индекс для адреса " + queryZip + " не найден"
                    );
                }
            }

            this.$emit("input", this.entries[0].data);
        } catch (e) {
            console.log(e);
        }
    }

    private async letssearch(): Promise<void> {
        if (this.isLoading) return;
        this.isLoading = true;
        try {
            if (this.from_bound || this.from_bound) {
                let requestModel = {
                    query: this.search,
                    from_bound: this.from_bound,
                    to_bound: this.to_bound
                };
                this.entries = await GeoService.makeAdvancedQuery(requestModel);
            } else {
                this.entries = await GeoService.makeQuery(this.search);
            }
        } catch (e) {
            console.log(e);
        }
        this.isLoading = false;
    }

    private debouncedSearch: Function = debounce(this.letssearch, 400);

    @Watch("search") async onSearch(v: string, vold: string) {
        if (v != vold) {
            if (v == "") this.value.value = ""; // Костыль, чтобы адрес можно было сбросить удалением всей строки ввода
            if (this.isNeedSearch) this.debouncedSearch();
            else this.isNeedSearch = true; //кастыль что бы не сбрасывались установленные иным способом данные данные
        }
    }

    async toLocate(): Promise<void> {
        if (this.isLoading) return;

        this.isLoading = true;
        try {
            let res = await GeoService.locateByIp();
            this.search = res[0].value;
        } catch (e) {}
        this.isLoading = false;
    }

    handleInput(val) {
        this.checkSuccess(val, this.rules);
        //this.$emit("input", val);
    }
    @Prop({ default: true }) successable: boolean;
    success: boolean = false;
    checkSuccess(value, rules) {
        console.log(value, rules);
        let state = false;
        for (let rule of rules) {
            if (typeof rule(value) === "string") {
                state = false;
                break;
            } else state = true;
        }
        this.success = state;
    }
}
